export function getSessionId() {
    let sessionId = localStorage.getItem('sessionId');
    if (!sessionId) {
      sessionId = crypto.randomUUID(); // Generate a unique ID
      localStorage.setItem('sessionId', sessionId);
    }
    return sessionId;
  }
  